import { useChurnSurveyQuestions } from './useChurnSurveyQuestions';
import { useSubmitChurnSurvey } from './useSubmitChurnSurvey';
import type { FormResult, ChurnSurveyQuestions } from '../types';
import { useChurnSurveyAnswers } from './useChurnSurveyAnswers';

interface UseChurnSurvey {
  questions?: ChurnSurveyQuestions;
  formReady: boolean;
  submitSurvey: (data: FormResult) => Promise<void>;
}

export function useChurnSurvey({
  accountId,
  subscriptionSubtotal,
}: {
  accountId: string;
  subscriptionSubtotal: string;
}): UseChurnSurvey {
  const { questions, formConfigData } = useChurnSurveyQuestions();
  const { implicitAnswers } = useChurnSurveyAnswers({
    accountId,
    survey: formConfigData,
    subscriptionSubtotal,
  });

  const { submitSurvey } = useSubmitChurnSurvey({ formConfigData, implicitAnswers });

  return {
    questions,
    formReady: implicitAnswers !== undefined,
    submitSurvey,
  };
}
